var exports = {
  "jw": "SearchFilterChip.module__chip___REdmT2",
  "xA": "SearchFilterChip.module__chipActive___REdmT2",
  "mD": "SearchFilterChip.module__chipIcon___REdmT2",
  "s5": "SearchFilterChip.module__chipContent___REdmT2",
  "Zl": "SearchFilterChip.module__chipLabel___REdmT2",
  "$j": "SearchFilterChip.module__chipLabelActive___REdmT2",
  "ET": "SearchFilterChip.module__chipValue___REdmT2",
  "cG": "SearchFilterChip.module__chipValueActive___REdmT2",
  "DT": "SearchFilterChip.module__removeButton___REdmT2",
};

module.exports = exports;
